import { BundleIncludedItem } from '../bundle'
import { IncludedItemViewModel } from '../components/ManageItemsInBundleViewModel/ManageItemsInBundleViewModel'
import { BundleIncludedItemIds } from './dtos'
import { BundleIncludedItem as BundleIncludedItemProto } from '@taxfyle/api-internal/internal/bundle_pb'

/**
 * Maps the BundleIncludedItemIds to BundleIncludedItemProto.
 *
 * @param payload
 * @returns
 */
export function mapIncludedItemsIdsToProto(
  payload: BundleIncludedItemIds[]
): BundleIncludedItemProto[] {
  const bundleIncludedItemsProto = payload.map((item) => {
    const includedItem = new BundleIncludedItemProto()
    includedItem.setInventoryItemId(item.inventory_item_id)
    includedItem.setIncludedQuantity(item.included_quantity)
    return includedItem
  })
  return bundleIncludedItemsProto
}

/**
 * Maps the BundleIncludedItem to BundleIncludedItemIds.
 *
 * @param includedItems
 * @returns
 */
export function mapBundleIncludedItemToIds(
  includedItems: BundleIncludedItem[]
): BundleIncludedItemIds[] {
  return includedItems.map((item) => {
    return {
      inventory_item_id: item.inventoryItemId,
      included_quantity: item.includedQuantity,
    } as BundleIncludedItemIds
  })
}

/**
 * Maps the IncludedItemViewModel to BundleIncludedItemIds.
 *
 * @param includedItems
 * @returns
 */
export function mapIncludedItemVmToIds(
  includedItems: IncludedItemViewModel[]
): BundleIncludedItemIds[] {
  return includedItems.map((item) => {
    return {
      inventory_item_id: item.inventoryItemId,
      included_quantity: item.includedQuantity,
    } as BundleIncludedItemIds
  })
}
